module.exports = __webpack_public_path__ + "img/tcm-teaching-info.efd5c548.png";